import Vue from 'vue';
import Component from 'vue-class-component';
import MobileFacade from '@/facades/MobileFacade';
import LocationCard from '@/components/Util/LocationCard/LocationCard.vue';
import { mapState } from 'vuex'

const HeaderProps = Vue.extend({
  props: {
    imgHome: {
      type: String,
      required: false,
    },

    imgLogo: {
      type: String,
      required: false,
    },

    tenancyId: {
      type: String,
      required: false,
    },
  },

  components: {
    LocationCard,
  },
});

@Component({
  name: "HeaderComponent",
  computed: {
    ...mapState({
      cx_zipCodeSearchCheck: (state: any) => state.globalSearch.zipCodeSearchCheck,
    }),
  },
})
export default class HeaderComponent extends HeaderProps {
  cx_home = this.imgHome
  cx_logo = this.imgLogo

  cx_isMobile = MobileFacade.isMobile()

  public cx_zipCodeSearchCheck?: boolean

  get cx_header_style(): any {
    return {
      backgroundImage: `url(${this.imgHome})`
    }
  }

  constructor() {
    super()
  }

  mounted(): void {
    this.cx_home = this.imgHome
    this.cx_logo = this.imgLogo
  }
}
